import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// Define types for state

interface AppState {
  loading: boolean;
  status: 'idle' | 'loading' | 'error' | 'success';
  errorMessage: string;
}

// Initial state
const initialState: AppState = {
  loading: false,
  status: 'idle',
  errorMessage: '',
};

// Create the slice
export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    requestFailed: (state, action: PayloadAction<string>) => {
      state.status = 'error';
      state.errorMessage = action.payload;
    },
    requestSucceeded: (state) => {
      state.status = 'success';
    },
    refreshApiStates: (state) => {
      state.loading = false;
      state.status = 'idle';
      state.errorMessage = '';
    },
  },
});

export const { startLoading, stopLoading, refreshApiStates, requestSucceeded, requestFailed } = appSlice.actions;

// Selectors
export const loading = (state: { app: AppState }) => state.app.loading;
export const errorMessage = (state: { app: AppState }) => state.app.errorMessage;
export const status = (state: { app: AppState }) => state.app.status;
